import React from "react";

import MarketingFooter from "components/marketing/MarketingFooter";
import MarketingHeader from "components/marketing/MarketingHeader";

interface MarketingLayoutProps {
  children: React.ReactNode;
}

const MarketingLayout = ({ children }: MarketingLayoutProps) => {
  return (
    <div className="marketing">
      <a href="#marketing-main-content" className="marketing__skip-link">
        Skip to main content
      </a>
      <MarketingHeader />
      <div id="marketing-main-content" className="marketing__content" tabIndex={-1}>
        {children}
      </div>
      <MarketingFooter />
    </div>
  );
};

export default MarketingLayout;
